import queryString from "query-string";
import {
  GetDate,
  GetIdsList,
  GetImprestStateList,
  GetMainType,
  GetSortField,
  GetSortType,
  GetSubject,
  GetTextSearch,
  GetUseHasAppendix
} from "../../../../../assets/convertUrlFilter";
import { ACCOUNT_REVIEW } from "../../../../../constants/sectionTypes";
import {
  ACCOUNT_TYPE,
  ALL_IMPREST_STATES_ARRAY,
  APPENDIX,
  END_DATE,
  FILE_TYPE,
  IMPREST_IDS,
  IMPREST_NUMBER,
  IMPREST_STATES,
  IMPREST_STATES_FOR_OTHER_REPORTS,
  PAYMENT_SUBJECTS,
  RECEIVE_SUBJECTS,
  SORT_FIELD,
  SORT_TYPE,
  START_DATE,
  TEAM_IDS,
  TEXT_SEARCH,
  TYPE,
  USER_IDS
} from "../../../../../constants/filters";
import { FILE_TYPES } from "../../../../../constants/file";

export const GetFilter = () => {
  let filters = queryString.parse(document.location.search);
  return filtersNormalize(filters);
};

const filtersNormalize = filters => {
  const tab =
    filters[TYPE] && filters[TYPE] <= 2 && filters[TYPE] >= 0
      ? filters[TYPE]
      : "0";
  return {
    [FILE_TYPE]: FILE_TYPES.WEB,
    [ACCOUNT_TYPE]: GetMainType(tab),
    [PAYMENT_SUBJECTS]: GetSubject(filters[PAYMENT_SUBJECTS]),
    [RECEIVE_SUBJECTS]: GetSubject(filters[RECEIVE_SUBJECTS]),
    [IMPREST_IDS]: GetIdsList(filters[IMPREST_IDS]),
    [START_DATE]: GetDate(filters[START_DATE]),
    [END_DATE]: GetDate(filters[END_DATE]),
    [TEXT_SEARCH]: GetTextSearch(filters[TEXT_SEARCH]),
    [APPENDIX]: GetUseHasAppendix(filters[APPENDIX]),
    [SORT_TYPE]: GetSortType(filters[SORT_TYPE]),
    [SORT_FIELD]: GetSortField(filters[SORT_FIELD], ACCOUNT_REVIEW),
    [USER_IDS]: GetIdsList(filters[USER_IDS]),
    [TEAM_IDS]: GetIdsList(filters[TEAM_IDS]),
    [IMPREST_STATES_FOR_OTHER_REPORTS]: GetImprestStateList(
      filters[IMPREST_STATES],
      ALL_IMPREST_STATES_ARRAY
    )
  };
};
